export default () => {
  let gridApi: { [key: string]: any }
  const selectedItems = ref<Array<{ [key: string]: any }>>([])
  const checkItems = ref<{ [key: string]: any }>({})
  const exceptItems = ref<{ [key: string]: any }>({})
  const selectionAll = ref<boolean>(false)
  const toggleSelectedAll = ref(false)
  let emits: any
  const selectionLoader = (_gridApi: { [key: string]: any }, _emits: any) => {
    gridApi = _gridApi
    emits = _emits
  }
  const checkEndSetCheckedAllByPage = () => {
    if (selectionAll.value) {
      return
    }
    if (
      (checkItems && checkItems.value.selectAll) ||
      (checkItems && checkItems.value.toggledNodes && checkItems.value.toggledNodes.length) ||
      selectedItems.value.length
    ) {
      let result = true
      const resultIdTableSelect = []
      const resultIdTableSelectNewPage = []
      const { currentPageSize, limit } = dataPaginator()
      for (let i = currentPageSize; i < limit; i++) {
        const rowData = gridApi.getDisplayedRowAtIndex(i)
        if (rowData) {
          const item = selectedItems.value.findIndex((data) => data.rowIndex === i)
          if (item === -1) {
            result = false
            resultIdTableSelectNewPage.push(rowData.id)
          } else {
            resultIdTableSelect.push(rowData.id)
          }
        }
      }
      if (!result && resultIdTableSelectNewPage.length + currentPageSize === limit) {
        gridApi.setServerSideSelectionState({
          selectAll: false,
          toggledNodes: []
        })
      } else if (result && resultIdTableSelect.length + currentPageSize === limit) {
        gridApi.setServerSideSelectionState({
          selectAll: true,
          toggledNodes: []
        })
      } else {
        gridApi.setServerSideSelectionState({
          selectAll: false,
          toggledNodes: resultIdTableSelect
        })
      }
    }
  }
  const unsetItemSelection = (data: { [key: string]: any }) => {
    const checkExits = selectedItems.value.findIndex((item) => item._id === data.data._id)
    if (checkExits !== -1) {
      selectedItems.value.splice(checkExits, 1)
    }
  }
  const setItemSelection = (data: { [key: string]: any }) => {
    const checkExits = selectedItems.value.findIndex((item) => item._id === data.data._id)
    if (checkExits === -1 && data.selectable) {
      data.data.tableId = data.id
      data.data.rowIndex = data.rowIndex
      selectedItems.value.push(data.data)
    }
  }
  const unsetItemSelectionToggleNode = () => {
    const { currentPageSize, limit } = dataPaginator()
    for (let i = currentPageSize; i < limit; i++) {
      if (!checkItems.value.toggledNodes.includes(i.toString())) {
        const indexSelectItem = selectedItems.value.findIndex((item) => item.tableId === i.toString())
        if (indexSelectItem !== -1) {
          selectedItems.value.splice(indexSelectItem, 1)
        }
      }
    }
  }
  const unsetItemSelectionCurrentPage = () => {
    const { currentPageSize, limit } = dataPaginator()
    for (let i = currentPageSize; i < limit; i++) {
      const indexSelectItem = selectedItems.value.findIndex((item) => item.rowIndex === i)
      if (indexSelectItem !== -1) {
        selectedItems.value.splice(indexSelectItem, 1)
      }
    }
  }
  const confirmDataMountedSelection = (selectedRows: { [key: string]: any }) => {
    let result = true
    const { currentPageSize, limit } = dataPaginator()
    const dataChecked = []
    for (let i = currentPageSize; i < limit; i++) {
      const indexSelectItem = selectedItems.value.findIndex((item) => item.rowIndex === i)
      if (indexSelectItem === -1) {
        dataChecked.push(i.toString())
        result = false
      }
    }

    if (result && !selectedRows.selectAll) {
      gridApi.setServerSideSelectionState({
        selectAll: true,
        toggledNodes: []
      })
    }
    if (!result && dataChecked.length + currentPageSize === limit && selectedRows.selectAll) {
      gridApi.setServerSideSelectionState({
        selectAll: false,
        toggledNodes: []
      })
    }
  }
  const customSelection = (paginator: boolean | undefined, selectedRows: { [key: string]: any }) => {
    const { currentPageSize, limit } = dataPaginator()
    // set item when selection on headers
    if (checkItems.value && checkItems.value.selectAll && checkItems.value.toggledNodes.length === 0) {
      for (let i = currentPageSize; i < limit; i++) {
        const data = gridApi.getDisplayedRowAtIndex(i)
        if (data) {
          setItemSelection(data)
        }
      }
    }

    if (checkItems.value && !checkItems.value.selectAll && checkItems.value.toggledNodes.length === 0) {
      unsetItemSelectionCurrentPage()
    }
    if (checkItems.value && checkItems.value.selectAll && checkItems.value.toggledNodes && (checkItems.value.toggledNodes.length === 0 || paginator)) {
      for (let i = currentPageSize; i < limit; i++) {
        const data = gridApi.getDisplayedRowAtIndex(i)
        if (data) {
          setItemSelection(data)
        }
      }
    }
    if (checkItems.value && !checkItems.value.selectAll && checkItems.value.toggledNodes && checkItems.value.toggledNodes.length > 0) {
      checkItems.value.toggledNodes.forEach((node: string) => {
        const data = gridApi.getRowNode(node)
        if (data) {
          setItemSelection(data)
        }
      })
      unsetItemSelectionToggleNode()
    }
    if (checkItems.value && checkItems.value.selectAll && checkItems.value.toggledNodes && checkItems.value.toggledNodes.length > 0) {
      for (let i = currentPageSize; i < limit; i++) {
        const data = gridApi.getDisplayedRowAtIndex(i)
        if (data) {
          if (!checkItems.value.toggledNodes.includes(data.id)) {
            setItemSelection(data)
          } else {
            unsetItemSelection(data)
          }
        }
      }
    }
    confirmDataMountedSelection(selectedRows)
  }

  const dataPaginator = () => {
    const page = gridApi && gridApi.paginationGetCurrentPage()
    const pageSize = gridApi && gridApi.paginationGetPageSize()
    const getTotalPage = gridApi && gridApi.paginationGetTotalPages()
    const getRowCount = gridApi && gridApi.paginationGetRowCount()
    let limit = (page + 1) * pageSize
    const currentPageSize = page * pageSize
    if (page + 1 === getTotalPage) {
      limit = page * pageSize + (getRowCount - page * pageSize)
    }
    return {
      page,
      pageSize,
      getTotalPage,
      getRowCount,
      limit,
      currentPageSize
    }
  }

  const onSelectionChanged = (event: any) => {
    const selectedRows = gridApi.getServerSideSelectionState()
    const { selectAll, toggledNodes } = selectedRows
    checkItems.value = selectedRows
    if (!selectionAll.value) {
      customSelection(undefined, selectedRows)
    } else if (selectionAll.value && !checkItems.value.selectAll && checkItems.value.toggledNodes.length === 0) {
      selectionAll.value = false
    }

    exceptItems.value = getDataExceptCheckedAll()
    emits('selectionChanged', selectedItems, {
      selectionAll: checkItems.value.selectAll,
      except: exceptItems.value
    })
  }
  const getDataExceptCheckedAll = () => {
    const result: Array<{ [key: string]: any }> = []
    checkItems.value.toggledNodes &&
      checkItems.value.toggledNodes.forEach((item: any) => {
        const data = gridApi.getRowNode(item)
        if (data) {
          result.push(data.data)
        }
      })
    return result
  }
  const dataSelection = () => {
    const ids: { [p: string]: any } = []
    if (Array.isArray(selectedItems.value)) {
      selectedItems.value.forEach((item: { [key: string]: any }) => {
        ids.push(item._id)
      })
    }
    const except: Array<{ [p: string]: any }> = getDataExceptCheckedAll()
    const exceptIds: Array<{ [p: string]: any }> = []
    if (Array.isArray(except)) {
      except.forEach((item) => {
        exceptIds.push(item._id)
      })
    }
    return {
      selectedItems: ids,
      selectionAll: selectionAll.value,
      except: selectionAll.value ? exceptIds : []
    }
  }
  const onSelectionAll = (val: boolean) => {
    selectionAll.value = val
    if (selectionAll.value) {
      selectedItems.value = []
      gridApi.setServerSideSelectionState({
        selectAll: true,
        toggledNodes: []
      })
      onSelectionChanged(null)
    } else {
      gridApi.setServerSideSelectionState({
        selectAll: false,
        toggledNodes: []
      })
    }
    nextTick(() => {
      toggleSelectedAll.value = false
    })
  }
  const clearAllSelection = () => {
    selectedItems.value = []
    gridApi.setServerSideSelectionState({
      selectAll: false,
      toggledNodes: []
    })
  }
  return {
    selectedItems,
    exceptItems,
    checkItems,
    selectionAll,
    toggleSelectedAll,
    selectionLoader,
    onSelectionChanged,
    checkEndSetCheckedAllByPage,
    onSelectionAll,
    dataSelection,
    clearAllSelection
  }
}
